import { Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { RootServiceService } from './dashboard/service/root-service.service';
import { GeocodingService } from './dashboard/service/geocoding.service';

// import { TranslateService } from '@ngx-translate/core';
declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'WALDO-ERP';
  // defaultLang: string;
  themeColor: string;

  private geoTrackerInterval: any = null;
  private geoLat: any = null;
  private geoLng: any = null;
  private geoAccuracy: any;

  // ─── Geo Tracker auto pause/resume state ───────────────────────────────────
  private geoWatchId: number | null = null;
  private configuredIntervalMinutes: number | null = null;
  private salesHourlyLogEnabled = false;
  private lastSaveTimestamp: number | null = null;
  private watchersInitialized = false;
  private isScreenActive = true;
  private isLocationStale = false;
  private lastLat: any = null;
  private lastLng: any = null;
  private lastLocationChangeTime = Date.now();
  private readonly STALE_LOCATION_THRESHOLD_MS = 2 * 60 * 60 * 1000; // 2 hours
  private readonly LOCATION_CHANGE_THRESHOLD_DEG = 0.0001; // ~11 meters
  private readonly onVisibilityChange = () => {
    this.isScreenActive = document.visibilityState === 'visible';
    if (this.isScreenActive) {
      console.log('[GeoTracker] Screen active - resuming tracker if eligible');
      this.resumeGeoTrackerIfEligible();
    } else {
      console.log('[GeoTracker] Screen inactive - pausing tracker');
      this.pauseGeoTrackerInterval();
    }
  };
  constructor(
    private elRef: ElementRef,
    private swUpdate: SwUpdate,
    private router: Router,
    private rootS: RootServiceService,
    private geocodingService: GeocodingService,
  ) // public translate: TranslateService
  {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        if (confirm("New version available. Load it?")) {
          window.location.reload();
        }
      });
    }

    this.registerServiceWorker();
    $(window).on('beforeinstallprompt', function (e) {
      console.log('beforeinstallprompt Event fired');
      // alert(123)
      e.preventDefault();
      this.deferredPrompt = e.originalEvent;

      return false;
    });

    // translate.addLangs(['en', 'fr']);
    // this.defaultLang=localStorage.getItem('lang');
    // translate.setDefaultLang(this.defaultLang);
    // localStorage.setItem('lang',this.defaultLang)
    const themeRaw = localStorage.getItem('ERP_themes');
    let derivedColor = '#900c3e';
    if (themeRaw) {
      try {
        const parsed = JSON.parse(themeRaw);
        // expecting { color: '#xxxxxx', border: '#yyyyyy' }
        derivedColor = parsed?.color || parsed; // if parsed string just color
      } catch {
        // not JSON, assume it's a plain color string
        derivedColor = themeRaw;
      }
    }
    this.themeColor = derivedColor;
    // Set on documentElement (not just app-root) so overlays appended directly to
    // <body> (e.g. ngx-bootstrap's bs-datepicker-container, modals) also inherit
    // the live color instead of falling back to the static :root default in styles.css.
    document.documentElement.style.setProperty('--theme-color', this.themeColor);
    this.elRef.nativeElement.style.setProperty('--theme-color', this.themeColor);
  }
  ngOnInit() {
    this.checkVersionFunct();
    this.checkForUpdates();
    this.initGeoTracker();
  }

  ngOnDestroy() {
    this.stopGeoTracker();
  }
  registerServiceWorker = async () => {
    console.log(navigator);
    if ('serviceWorker' in navigator) {
      // alert(1);
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('src/sw.js').then(
          (registration) => {
            console.log(
              'Service Worker registration completed with scope: ',
              registration.scope
            );
          },
          (err) => {
            console.log('Service Worker registration failed', err);
          }
        );
      });
    } else {
      console.log('Service Workers not supported');
    }
  };
  deferredPrompt: any;
  showButton = false;
  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    console.log(e);
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    this.showButton = true;
    console.log(this.deferredPrompt);
  }
  addToHomeScreen() {
    // hide our user interface that shows our A2HS button
    this.showButton = false;
    // Show the prompt

    // if (this.deferredPrompt) {
    // alert(this.deferredPrompt);
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
      } else {
        console.log('User dismissed the A2HS prompt');
      }
      this.deferredPrompt = null;
    });
    // }
  }

  checkVersionFunct(): void {
    fetch('./assets/version.json' + '?nocache=' + new Date().getTime())
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }
        return res.json();
      })
      .then((data) => {
        const latestVersion = data.version;
        const currentVersion = localStorage.getItem('version');

        if (!currentVersion) {
          localStorage.setItem('version', latestVersion);
        } else if (currentVersion !== latestVersion) {
          localStorage.setItem('version', latestVersion);
          window.location.reload();
        }
      })
      .catch((err) => {
        console.error('Failed to fetch version.json:', err);
        // Fallback: continue with current version or implement retry logic
        // Could also show user notification for critical issues
      });
  }

  checkForUpdates() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkVersionFunct();
      });
  }

  // ─── Background Geo Tracker ──────────────────────────────────────────────────

  /** Start the background location tracking only when the user is logged in. */
  initGeoTracker() {
    const apiSecret = localStorage.getItem('waldo_apiSecret');
    if (!apiSecret) return;

    const adminYn = localStorage.getItem('waldo_drkAdminYN');
    if (adminYn !== 'N') {
      console.log('[GeoTracker] User is admin or invalid admin flag; tracker disabled.');
      return;
    }

    this.rootS.getActiveGeneric('SALES_HOURLY_LOG_YN', '').subscribe(
      (response: any[]) => {
        if (!this.isYes(response?.[0]?.value)) {
          console.log('[GeoTracker] SALES_HOURLY_LOG_YN is not enabled; tracker disabled.');
          this.salesHourlyLogEnabled = false;
          this.pauseGeoTrackerInterval();
          return;
        }

        this.salesHourlyLogEnabled = true;
        this.rootS.getActiveGeneric('GEO_TRACKER_TIMER', '').subscribe(
          (timerRes: any[]) => {
            const parsed = timerRes?.length > 0 ? parseFloat(timerRes[0]?.value) : NaN;
            if (!isNaN(parsed) && parsed > 0) {
              this.configuredIntervalMinutes = parsed;
              this.setupAutoPauseResumeWatchers();
              this.startGeoTrackerInterval(parsed);
            } else {
              console.warn('[GeoTracker] GEO_TRACKER_TIMER value missing/invalid, tracker not started');
            }
          },
          (error) => {
            console.warn('[GeoTracker] Failed to fetch GEO_TRACKER_TIMER, tracker not started', error);
          }
        );
      },
      (error) => {
        console.warn('[GeoTracker] Failed to fetch SALES_HOURLY_LOG_YN', error);
      }
    );
  }

  private isYes(value: any): boolean {
    return String(value || '').trim().toUpperCase() === 'Y';
  }

  private ensureSalesHourlyLogEnabled(): Promise<boolean> {
    return new Promise((resolve) => {
      const adminYn = localStorage.getItem('waldo_drkAdminYN');
      if (adminYn !== 'N') {
        resolve(false);
        return;
      }

      this.rootS.getActiveGeneric('LY_LOG_YN', '').subscribe(
        (response: any[]) => {
          const enabled = this.isYes(response?.[0]?.value);
          resolve(enabled);
        },
        (error) => {
          console.warn('[GeoTracker] Failed to validate SALES_HOURLY_LOG_YN', error);
          resolve(false);
        }
      );
    });
  }

  /** (Re)start the geo-tracker interval, guarding against duplicate/stacked intervals. */
  private startGeoTrackerInterval(intervalMinutes: number) {
    // ✅ Clear any existing timeout first so repeated calls never stack.
    this.pauseGeoTrackerInterval();

    this.configuredIntervalMinutes = intervalMinutes;
    console.log(`[GeoTracker] Starting scheduler: ${intervalMinutes} minute(s)`);

    // ✅ Call once immediately, then schedule the next save.
    this.fetchAndSaveLocation();
    this.scheduleNextGeoSave();
  }

  private scheduleNextGeoSave() {
    if (!this.configuredIntervalMinutes) return;
    this.pauseGeoTrackerInterval();

    const intervalMs = this.configuredIntervalMinutes * 60 * 1000;
    this.geoTrackerInterval = window.setTimeout(() => {
      this.triggerGeoSave();
    }, intervalMs);

    console.log(`[GeoTracker] Scheduled next save in ${this.configuredIntervalMinutes} minute(s)`);
  }

  private triggerGeoSave() {
    this.fetchAndSaveLocation();
    this.scheduleNextGeoSave();
  }

  /** Set up the screen-visibility and location watchers used to auto pause/resume the tracker. Idempotent. */
  private setupAutoPauseResumeWatchers() {
    if (this.watchersInitialized) return;
    this.watchersInitialized = true;

    this.isScreenActive = document.visibilityState === 'visible';
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    this.startLocationWatcher();
  }

  /** Continuously watch device position (independent of the save interval) to detect staleness/movement. */
  private startLocationWatcher() {
    if (!navigator.geolocation || this.geoWatchId !== null) return;
    this.geoWatchId = navigator.geolocation.watchPosition(
      (position) => this.handleWatchedPosition(position),
      (error) => console.warn('[GeoTracker] watchPosition failed', error),
      { enableHighAccuracy: false, maximumAge: 5 * 60 * 1000 }
    );
  }

  private handleWatchedPosition(position: any) {
    const { latitude, longitude } = position.coords;
    const hasMoved =
      this.lastLat == null ||
      this.lastLng == null ||
      !this.isSameLocation(latitude, longitude, this.lastLat, this.lastLng);

    if (hasMoved) {
      this.lastLat = latitude;
      this.lastLng = longitude;
      this.lastLocationChangeTime = Date.now();
      if (this.isLocationStale) {
        console.log('[GeoTracker] Location changed - resuming tracker');
        this.isLocationStale = false;
        this.resumeGeoTrackerIfEligible();
      }
    } else if (!this.isLocationStale && Date.now() - this.lastLocationChangeTime >= this.STALE_LOCATION_THRESHOLD_MS) {
      console.log('[GeoTracker] Same location for 2h - pausing tracker');
      this.isLocationStale = true;
      this.pauseGeoTrackerInterval();
    }
  }

  private isSameLocation(lat1: number, lng1: number, lat2: number, lng2: number): boolean {
    return (
      Math.abs(lat1 - lat2) < this.LOCATION_CHANGE_THRESHOLD_DEG &&
      Math.abs(lng1 - lng2) < this.LOCATION_CHANGE_THRESHOLD_DEG
    );
  }

  /** Resume the tracker only if it isn't already running and conditions (screen active, location not stale) allow it. */
  private resumeGeoTrackerIfEligible() {
    if (this.geoTrackerInterval || !this.configuredIntervalMinutes) return;
    if (this.isScreenActive && !this.isLocationStale) {
      this.startGeoTrackerInterval(this.configuredIntervalMinutes);
    }
  }

  /** Pause just the save interval (temporary) without tearing down the watchers, so it can auto-resume. */
  private pauseGeoTrackerInterval() {
    if (this.geoTrackerInterval) {
      clearTimeout(this.geoTrackerInterval);
      this.geoTrackerInterval = null;
    }
  }

  private async fetchAndSaveLocation() {
    if (this.configuredIntervalMinutes && this.lastSaveTimestamp) {
      const elapsedMs = Date.now() - this.lastSaveTimestamp;
      const expectedMs = this.configuredIntervalMinutes * 60 * 1000;
      if (elapsedMs < expectedMs) {
        console.log(
          `[GeoTracker] Skipping save because only ${Math.round(elapsedMs / 1000)}s elapsed; expected ${Math.round(expectedMs / 1000)}s.`
        );
        return;
      }
    }

    const enabled = await this.ensureSalesHourlyLogEnabled();
    if (!enabled) {
      console.log('[GeoTracker] SALES_HOURLY_LOG_YN disabled; stopping tracker.');
      this.salesHourlyLogEnabled = false;
      this.pauseGeoTrackerInterval();
      return;
    }

    try {
      const position: any = await this.geocodingService.getCurrentLocation();
      this.geoLat = position.coords.latitude;
      this.geoLng = position.coords.longitude;
      this.geoAccuracy = position.coords.accuracy
        ? `${position.coords.accuracy.toFixed(0)}`
        : '0';
      // ✅ Save only after coords are resolved
      this.saveSalesmanLocationBackground();
    } catch (err) {
      console.warn('[GeoTracker] Could not get location, using last known coords:', err);
      // ✅ Still save with last known / fallback coords
      this.saveSalesmanLocationBackground();
    }
  }

  private async saveSalesmanLocationBackground() {
    const device = localStorage.getItem('deviceId');
    const latitude = this.geoLat ?? 0;
    const longitude = this.geoLng ?? 0;

    // ✅ Actually await battery level instead of ignoring the promise
    let batteryPercent = '100';
    const nav: any = navigator;
    if (nav.getBattery) {
      try {
        const battery = await nav.getBattery();
        batteryPercent = `${Math.round(battery.level * 100)}`;
      } catch (e) {
        console.warn('[GeoTracker] Battery fetch failed:', e);
      }
    }

    this.lastSaveTimestamp = Date.now();
    this.rootS.saveSalesmanLocApi(
      latitude,
      longitude,
      'HOURLY',
      device,
      this.geoAccuracy,
      batteryPercent
    ).subscribe(
      (res) => console.log('[GeoTracker] Location saved:', res),
      (err) => console.warn('[GeoTracker] Failed to save location:', err)
    );
  }

  /** Fully stop background geo-tracking: interval, location watcher and visibility listener. */
  private stopGeoTracker() {
    this.pauseGeoTrackerInterval();

    if (this.geoWatchId !== null) {
      navigator.geolocation.clearWatch(this.geoWatchId);
      this.geoWatchId = null;
    }

    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.watchersInitialized = false;
  }
}
